export const formatCurrency = (
  value: number | string | null | undefined,
  currency: string = "USD",
  locale: string = "es-US"
) => {
  const amount = typeof value === "string" ? Number(value) : (value ?? 0)
  const safeAmount = Number.isFinite(amount) ? (amount as number) : 0

  return safeAmount.toLocaleString(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    currencyDisplay: "symbol",
  })
}

export const formatDiscountedCurrency = (
  value: number | string | null | undefined,
  currency: string = "USD",
  locale: string = "es-US"
) => {
  const amount = typeof value === "string" ? Number(value) : (value ?? 0)
  const safeAmount = Number.isFinite(amount) ? (amount as number) : 0
  const roundedUp = Math.ceil(safeAmount)

  return roundedUp.toLocaleString(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    currencyDisplay: "symbol",
  })
}
